import { gql, useMutation } from '@apollo/client';
import type {
  DeleteTemplateMutation,
  DeleteTemplateMutationVariables,
} from '../graphql/generated/graphqlTypes';
import {
  getTemplateOwnersQueryUpdate,
  getTemplateQueryUpdate,
} from './TemplatesModal';

const DELETE_TEMPLATE = gql`
  mutation deleteTemplate($id: ID!) {
    template: deleteTemplate(id: $id) {
      id
      topicOwner {
        id
      }
      userOwner {
        id
      }
    }
  }
`;

export default function useDeleteTemplateMutation() {
  const response = useMutation<
    DeleteTemplateMutation,
    DeleteTemplateMutationVariables
  >(DELETE_TEMPLATE, {
    update: (cache, { data: deletedData }) => {
      const topicOwner = deletedData?.template?.topicOwner;
      const userOwner = deletedData?.template?.userOwner;

      if (userOwner) {
        getTemplateQueryUpdate('template', false)(cache, { data: deletedData });
      }
      if (topicOwner) {
        getTemplateOwnersQueryUpdate(
          topicOwner.id ?? null,
          null,
          'template',
        )(cache, { data: deletedData });
      }
    },
  });

  return response;
}
